"use client";

import type { MouseEvent, PropsWithChildren } from "react";
import useAllGamesNavigate from "./useAllGamesNavigate";

const AllGamesNavigationLinks: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useAllGamesNavigate();

  const handleClickCapture = (event: MouseEvent<HTMLDivElement>) => {
    const link = getNavigableLink(event);
    if (!link) {
      return;
    }
    event.preventDefault();
    navigate(`${link.pathname}${link.search}`);
  };

  return (
    <div className="contents" onClickCapture={handleClickCapture}>
      {children}
    </div>
  );
};

const getNavigableLink = (event: MouseEvent<HTMLDivElement>) => {
  if (
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  ) {
    return null;
  }
  if (!(event.target instanceof Element)) {
    return null;
  }
  const link = event.target.closest("a");
  if (!link || link.target || link.origin !== window.location.origin) {
    return null;
  }
  return link;
};

export default AllGamesNavigationLinks;
